import { Component } from '@angular/core';
import { FieldType } from "@ngx-formly/core";

@Component({
  selector: 'app-section-error-message',
  templateUrl: './section-error-message.component.html',
  styleUrls: ['./section-error-message.component.scss']
})
export class SectionErrorMessageComponent extends FieldType {

}
